import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const mural = defineConnector({
  identifier: "mural",
  name: "Mural",
  tagLine: "Visual collaboration whiteboard",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://app\\.mural\\.co/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create a Mural app",
      items: [
        {
          kind: "markdown",
          content:
            "Go to the [Mural Developer Portal](https://developers.mural.co/) and create a new application. You'll need to sign in with your Mural account and register your app to get OAuth credentials.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/mural/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your Mural account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your Mural account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () =>
      "https://app.mural.co/api/public/v1/authorization/oauth2",
    tokenEndpoint: () =>
      "https://app.mural.co/api/public/v1/authorization/oauth2/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://app.mural.co/api/public/v1/users/me",
  },
});
